import React, { useState } from 'react'
import Select, { StylesConfig } from "react-select";
import TextField from '../../../../../../core/common/textFields/TextField';
import { svgIcons } from '../../../../../../style/fonts/SvgIcons';
import { DatePicker, TimePicker, TimePickerProps } from 'antd';
import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import DateField from '../../../../../../core/common/textFields/DateField';


const GeneralTabCol3 = ({ isReadOnly, formik, leadsInquiryLookups, getdefaultLookups }: any) => {

    const [selectedCloseDate, setSelectedCloseDate] = useState<Date | null>(null);

    const [selectedContractDate, setSelectedContractDate] = useState<Date | null>(null);


    dayjs.extend(customParseFormat);
    const onChangeContractTime: TimePickerProps['onChange'] = (time, timeString) => {
        const formattedTime = time ? dayjs(time).format("h:mm A") : '';
        formik.setFieldValue('contractTime', formattedTime);
    };

    const onChangeEstimatedCloseTime: TimePickerProps['onChange'] = (time, timeString) => {
        const formattedTime = time ? dayjs(time).format("h:mm A") : '';
        formik.setFieldValue('estimatedCloseTime', formattedTime);
    };
    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };
    const handleEstimateDateChange = (date: Dayjs | null) => {
        // setSelectedCloseDate(date);
        formik.setFieldValue('estimatedCloseDate', date)
    };


    const handleContractDateChange = (date: Dayjs | null) => {
        // setSelectedContractDate(date);
        formik.setFieldValue('contractDate', date)
    };


    return (
        <>
            <div className='card'>
                <div className='card-body'>
                    <h6 className='mb-2 mt-2'>
                        Budget & Range (Customer | Lead Taker | PDM)
                    </h6>
                    <>
                        <TextField
                            label="Budget Range Min"
                            type="number"
                            {...formik.getFieldProps("budgetRangeMin")}
                            disabled={isReadOnly}
                            fieldIcon={true}

                        />
                    </>
                    <>
                        <TextField
                            label="Budget Range Max"
                            type="number"
                            {...formik.getFieldProps("budgetRangeMax")}
                            disabled={isReadOnly}
                            fieldIcon={true}

                        />
                    </>
                    <>
                        <TextField
                            label="Range Indicated Min"
                            type="number"
                            {...formik.getFieldProps("rangeIndicatedMin")}
                            disabled={isReadOnly}
                            fieldIcon={true}

                        />
                    </>
                    <>
                        <TextField
                            label="Range Indicated Max"
                            type="number"
                            {...formik.getFieldProps("rangeIndicatedMax")}
                            disabled={isReadOnly}
                            fieldIcon={true}

                        />
                    </>
                    <>
                        <TextField
                            label="Range Assessed Min"
                            type="number"
                            {...formik.getFieldProps("rangeAssessedMin")}
                            disabled={isReadOnly}
                            fieldIcon={true}

                        />
                    </>
                    <>
                        <TextField
                            label="Range Assessed Max"
                            type="number"
                            {...formik.getFieldProps("rangeAssessedMax")}
                            disabled={isReadOnly}
                            fieldIcon={true}

                        />
                    </>
                </div>
            </div>
            <div className='card'>
                <div className='card-body'>
                    <h5 className='mb-0'>
                        Estimates
                    </h5>
                    <div className="form-wrap">
                        <label className="input-label">Purchase Time Frame <span className='text-danger'>*</span></label>
                        <Select
                            styles={customStyles}
                            className="select"
                            options={leadsInquiryLookups?.result?.Lst_PurchaseTimeFrame
                                ?.map((option: any) => ({
                                    label: option?.value,
                                    value: option?.id
                                }))}
                            value={
                                formik.values?.lst_PurchaseTimeFrame
                                    ?.id
                                    ? {
                                        value: formik.values?.lst_PurchaseTimeFrame?.id,
                                        label: formik.values?.lst_PurchaseTimeFrame?.value || '',
                                    }
                                    : null
                            }
                            isDisabled={isReadOnly}
                            onChange={(selectedOption: any) => {
                                formik.setFieldValue('lst_PurchaseTimeFrame.id', selectedOption.value);
                                formik.setFieldValue('lst_PurchaseTimeFrame.value', selectedOption.label);
                            }}
                        />
                    </div>
                    <>
                        <TextField
                            label="Cost Book Amount"
                            type="number"
                            {...formik.getFieldProps("costBookAmount")}
                            disabled={isReadOnly}
                            fieldIcon={true}

                        />
                    </>
                    <>
                        <TextField
                            label="PDM Job Estimated"
                            type="number"
                            {...formik.getFieldProps("pdmJobEstimated")}
                            disabled={isReadOnly}
                            required
                            fieldIcon={true}

                        />
                    </>
                    <div className='d-flex gap-2'>
                        <div className="col-md-6">
                            <label className='input-label'>Estimated Close Date</label>
                            <div className="form-wrap icon-form">
                                <span className="form-icon">
                                    <i className="ti ti-calendar-check" />
                                </span>
                                <DatePicker
                                    className="form-control datetimepicker deals-details "
                                    // selected={selectedFreshAptmentDate}
                                    onChange={handleEstimateDateChange}
                                    value={formik.values?.estimatedCloseDate ? dayjs(formik.values?.estimatedCloseDate, 'YYYY-MM-DD') : null}
                                    format="DDD-MM-yyyy"
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <label className="input-label">
                                Time
                            </label>
                            <TimePicker
                                placeholder="Select Time"
                                className="form-control datetimepicker-time"
                                onChange={onChangeEstimatedCloseTime}
                                value={formik.values?.estimatedCloseTime && dayjs(formik.values.estimatedCloseTime, "h:mm A").isValid()
                                    ? dayjs(formik.values.estimatedCloseTime, "h:mm A")
                                    : null}
                                format="h:mm A"
                                use12Hours
                                disabled={isReadOnly}
                            />
                        </div>
                    </div>

                </div>
            </div>
            <div className='card'>
                <div className='card-body'>
                    <h5 className='mb-0'>
                        Financing
                    </h5>
                    <div className="form-wrap">
                        <label className="input-label">Project Financing <span className='text-danger'>*</span></label>
                        <Select
                            styles={customStyles}
                            className="select"
                            options={leadsInquiryLookups?.result?.Lst_ProjectFinancing
                                ?.map((option: any) => ({
                                    label: option?.value,
                                    value: option?.id
                                }))}
                            value={
                                formik.values?.lst_ProjectFinancing
                                    ?.id
                                    ? {
                                        value: formik.values?.lst_ProjectFinancing?.id,
                                        label: formik.values?.lst_ProjectFinancing?.value || '',
                                    }
                                    : null
                            }
                            isDisabled={isReadOnly}
                            onChange={(selectedOption: any) => {
                                formik.setFieldValue('lst_ProjectFinancing.id', selectedOption.value);
                                formik.setFieldValue('lst_ProjectFinancing.value', selectedOption.label);
                            }}
                        />
                    </div>
                    <>
                        <TextField
                            label="Home Purchase Price"
                            type="number"
                            {...formik.getFieldProps("homePurchasePrice")}
                            disabled={isReadOnly}
                            fieldIcon={true}

                        />
                    </>
                    <>
                        <TextField
                            label="Mortgage Term"
                            type="number"
                            {...formik.getFieldProps("mortgageTerm")}
                            disabled={isReadOnly}
                            fieldIcon={true}

                        />
                    </>
                    <>
                        <TextField
                            label="Cash to Invest"
                            type="number"
                            {...formik.getFieldProps("cashToInvest")}
                            disabled={isReadOnly}
                            fieldIcon={true}
                            required
                        />
                    </>
                    <>
                        <TextField
                            label="Current Mortgage Balance"
                            type="number"
                            {...formik.getFieldProps("currentMortgageBalance")}
                            disabled={isReadOnly}
                            fieldIcon={true}

                        />
                    </>
                    <div className="col-md-12">
                        <label className='input-label'>Mortgage Rate </label>
                        <Select
                            styles={customStyles}
                            className="select"
                            options={leadsInquiryLookups?.result?.Lst_MortgageRate
                                ?.map((option: any) => ({
                                    label: option?.value,
                                    value: option?.id
                                }))}
                            value={
                                formik.values?.lst_MortgageRate?.id
                                    ? {
                                        value: formik.values?.lst_MortgageRate?.id,
                                        label: formik.values?.lst_MortgageRate?.value || '',
                                    }
                                    : null
                            }
                            isDisabled={isReadOnly}
                            onChange={(selectedOption: any) => {
                                formik.setFieldValue('lst_MortgageRate.id', selectedOption.value);
                                formik.setFieldValue('lst_MortgageRate.value', selectedOption.label);
                            }}
                        />
                    </div>
                    <>
                        <TextField
                            label="Financed Amount"
                            type="number"
                            icon={svgIcons.LockIcon}
                            {...formik.getFieldProps("financedAmount")}
                            disabled={isReadOnly}
                            fieldIcon={true}
                            required
                        />
                    </>
                    <>
                        <TextField
                            label="Home Current Value"
                            type="number"
                            icon={svgIcons.LockIcon}
                            {...formik.getFieldProps("homeCurrentValue")}
                            disabled={isReadOnly}
                            fieldIcon={true}

                        />
                    </>
                </div>
            </div>

            <div className='card'>
                <div className='card-body'>
                    <h5>
                        Contract
                    </h5>
                    <div className="col-md-12">
                        <label className='input-label'>Contract Status </label>
                        <Select
                            styles={customStyles}
                            className="select"
                            options={leadsInquiryLookups?.result?.Lst_ContractStatus
                                ?.map((option: any) => ({
                                    label: option?.value,
                                    value: option?.id
                                }))}
                            value={
                                formik.values?.lst_ContractStatus?.id
                                    ? {
                                        value: formik.values?.lst_ContractStatus?.id,
                                        label: formik.values?.lst_ContractStatus?.value || '',
                                    }
                                    : null
                            }
                            isDisabled={isReadOnly}
                            onChange={(selectedOption: any) => {
                                formik.setFieldValue('lst_ContractStatus.id', selectedOption.value);
                                formik.setFieldValue('lst_ContractStatus.value', selectedOption.label);
                            }}
                        />
                    </div>
                    <>
                        <TextField
                            label="Contract Amount"
                            type="number"
                            icon={svgIcons.LockIcon}
                            {...formik.getFieldProps("contractAmount")}
                            disabled={isReadOnly}
                            fieldIcon={true}
                            required
                        />
                    </>
                    <div className='d-flex gap-2'>
                        <div className="col-md-6">
                            <label className='input-label'>Contract Date</label>
                            <div className="form-wrap icon-form">
                                <span className="form-icon">
                                    <i className="ti ti-calendar-check" />
                                </span>
                                <DatePicker
                                    className="form-control datetimepicker deals-details "
                                    onChange={handleContractDateChange}
                                    disabled={isReadOnly}
                                    // value={formik?.values?.contractDate}
                                    value={formik.values?.contractDate ? dayjs(formik.values?.contractDate, 'YYYY-MM-DD') : null}
                                    format='MMM-DD-YYYY'
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <label className="input-label">
                                Time
                            </label>
                            <TimePicker
                                placeholder="Select Time"
                                className="form-control datetimepicker-time"
                                onChange={onChangeContractTime}
                                value={formik.values?.contractTime && dayjs(formik.values.contractTime, "h:mm A").isValid()
                                    ? dayjs(formik.values.contractTime, "h:mm A")
                                    : null}
                                format="h:mm A"
                                use12Hours
                                disabled={isReadOnly}
                            />
                        </div>
                    </div>
                    <div className="col-md-12">
                        <label className='input-label'>Contract Cermony Location Code </label>
                        <Select
                            styles={customStyles}
                            className="select"
                            options={leadsInquiryLookups?.result?.Lst_ContractCeremonyLocationCode
                                ?.map((option: any) => ({
                                    label: option?.value,
                                    value: option?.id
                                }))}
                            value={
                                formik.values?.lst_ContractCeremonyLocationCode?.id
                                    ? {
                                        value: formik.values?.lst_ContractCeremonyLocationCode?.id,
                                        label: formik.values?.lst_ContractCeremonyLocationCode?.value || '',
                                    }
                                    : null
                            }
                            isDisabled={isReadOnly}
                            onChange={(selectedOption: any) => {
                                formik.setFieldValue('lst_ContractCeremonyLocationCode.id', selectedOption.value);
                                formik.setFieldValue('lst_ContractCeremonyLocationCode.value', selectedOption.label);
                            }}
                        />
                    </div>
                    <div className="col-md-12">
                        <label className='input-label'>Contract Confirmed </label>
                        <Select
                            styles={customStyles}
                            className="select"
                            options={leadsInquiryLookups?.result?.Lst_ContractConfirmed
                                ?.map((option: any) => ({
                                    label: option?.value,
                                    value: option?.id
                                }))}
                            value={
                                formik.values?.lst_ContractConfirmed?.id
                                    ? {
                                        value: formik.values?.lst_ContractConfirmed?.id,
                                        label: formik.values?.lst_ContractConfirmed?.value || '',
                                    }
                                    : null
                            }
                            isDisabled={isReadOnly}
                            onChange={(selectedOption: any) => {
                                formik.setFieldValue('lst_ContractConfirmed.id', selectedOption.value);
                                formik.setFieldValue('lst_ContractConfirmed.value', selectedOption.label);
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default GeneralTabCol3